import {
  getWidgetDefinitions,
  PartnerIntegrationsSettings,
} from '@dixa/lib-integrations-partner-widgets';
import { Page } from '@dixa/lib-shared-habla';
import { client as elevioClient } from 'elevio';
import { config } from 'lib-shared-backend-config';

import { articles } from 'utils/elevio';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { SettingsIntegrationsDocumentationButton } from '../../components/documentationButton/documentationButton';

import { PartnerIntegrationsWidgetError } from './components/error';
import {
  capitalizeFirstLetter,
  integrationsBaseRoute,
} from './partnerIntegrationsWidget.utils';
import { usePartnerIntegrationNotification } from './utils';

const widgetDefinitions = getWidgetDefinitions();

/**
 * The page where a partner integration widget configuration can be updated or
 * deleted. The form data, queries, mutations and validation is taking place in
 * `PartnerIntegrationsSettings`.
 */
export const PartnerIntegrationsWidgetView = (): JSX.Element => {
  const navigate = useAppNavigate();
  const { id, type } = useAppPathParams(
    '/settings/integrations/partner-widget/:type/:id',
  );
  const showNotification = usePartnerIntegrationNotification();

  const integrationType = type?.toUpperCase();
  const isValidWidgetType = integrationType in widgetDefinitions;

  const title =
    isValidWidgetType && type
      ? `${capitalizeFirstLetter(type)} widget settings`
      : 'Widget settings';

  return (
    <Page.Section
      title={title}
      titleMeta={
        type in articles.settings.partners.widget && (
          <SettingsIntegrationsDocumentationButton
            onClick={() =>
              elevioClient.openArticle(articles.settings.partners.widget[type])
            }
          />
        )
      }
    >
      {id && isValidWidgetType ? (
        <PartnerIntegrationsSettings
          configuration={{
            baseUrl: config.url.partnerIntegrations,
          }}
          integrationId={id}
          type={integrationType}
          handleRedirect={() =>
            navigate({ path: integrationsBaseRoute }, { replace: true })
          }
          showNotification={showNotification}
        />
      ) : (
        <PartnerIntegrationsWidgetError />
      )}
    </Page.Section>
  );
};
